// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Editor_editor__shROf .ant-upload-select-picture {
  width: 100%;
}

.Editor_header__DMbY9 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}

.Editor_title__d6Vpo {
  color: var(--darkGray);
  font-family: BebasNeue;
  font-weight: 700;
  font-size: 20px;
}

.Editor_label__s6Cc8 {
  font-weight: 500;
  color: var(--darkGray);
  font-size: 12px;
}

.Editor_input__ykjJN,
.Editor_input__ykjJN .ant-select-selector {
  background-color: #fbfbfb !important;
  border-color: #d2d2d2 !important;
  border-radius: 4px !important;
}

.Editor_itemColumn__TRlxY {
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.Editor_uploadImage__cxeql {
  border: 1px solid #d2d2d2;
  background-color: #fbfbfb;
  color: #383838;
  font-weight: 500;
  width: 100%;
  height: 41px;
  border-radius: 4px;
}

.Editor_center__STrdu {
  text-align: center;
  display: block;
  margin-top: 5px;
}

.Editor_labelSection__uNS7A {
  display: block;
  margin-bottom: 15px;
  margin-top: 40px;
}

.Editor_hoursList__5GvkH {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
}

.Editor_labelHour__hSRoH {
  width: 80px;
  text-align: left;
}

.Editor_searchbox__1SfpN {
  box-sizing: border-box;
  border: 1px solid transparent;
  width: 250px;
  height: 40px;
  padding: 0 15px;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(100, 100, 100, 0.3);
  font-size: 14px;
  outline: none;
  text-overflow: ellipses;
  position: absolute;
  left: 15px;
  top: 15px;
}

.Editor_mapWrapper__xVpRo {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}

.Editor_gps__MDS0J {
  position: absolute;
  height: 34.65px;
  width: 45px;
  margin-top: -17.325px;
  text-shadow: 0 2px 6px rgba(100, 100, 100, 0.3);
}

.Editor_itemSubmit__OIaKS {
  margin-bottom: 0;
  text-align: right;
  margin-top: 20px;
}

.Editor_submit__MlQSb {
  width: 250px;
  font-weight: 700;
  font-size: 13px;
}

.Editor_delete__8kZqC {
  width: 150px;
  margin-right: 20px;
}

.Editor_preview__T0QpS {
  background-color: #f3f3f3;
  height: 140px;
  margin-bottom: 15px;
  border-radius: 4px;
  background-size: cover;
  background-position: center;
}

.Editor_formItem__FiWEH{
  display: flex;
  gap:10px;
}

.Editor_plusMinusIcon__LZenC{
  cursor: pointer;
}

.Editor_innerHour__8xcbv{
  width: 84%;
}

@media only screen and (max-width:650px) {
  .Editor_innerHour__8xcbv{
    width: 88%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/branches/styles/Editor.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,8CAA8C;EAC9C,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;AAC7B;;AACA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".editor :global(.ant-upload-select-picture) {\n  width: 100%;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 15px;\n}\n\n.title {\n  color: var(--darkGray);\n  font-family: BebasNeue;\n  font-weight: 700;\n  font-size: 20px;\n}\n\n.label {\n  font-weight: 500;\n  color: var(--darkGray);\n  font-size: 12px;\n}\n\n.input,\n.input :global(.ant-select-selector) {\n  background-color: #fbfbfb !important;\n  border-color: #d2d2d2 !important;\n  border-radius: 4px !important;\n}\n\n.itemColumn {\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.uploadImage {\n  border: 1px solid #d2d2d2;\n  background-color: #fbfbfb;\n  color: #383838;\n  font-weight: 500;\n  width: 100%;\n  height: 41px;\n  border-radius: 4px;\n}\n\n.center {\n  text-align: center;\n  display: block;\n  margin-top: 5px;\n}\n\n.labelSection {\n  display: block;\n  margin-bottom: 15px;\n  margin-top: 40px;\n}\n\n.hoursList {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n}\n\n.labelHour {\n  width: 80px;\n  text-align: left;\n}\n\n.searchbox {\n  box-sizing: border-box;\n  border: 1px solid transparent;\n  width: 250px;\n  height: 40px;\n  padding: 0 15px;\n  border-radius: 6px;\n  box-shadow: 0 2px 6px rgba(100, 100, 100, 0.3);\n  font-size: 14px;\n  outline: none;\n  text-overflow: ellipses;\n  position: absolute;\n  left: 15px;\n  top: 15px;\n}\n\n.mapWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.gps {\n  position: absolute;\n  height: 34.65px;\n  width: 45px;\n  margin-top: -17.325px;\n  text-shadow: 0 2px 6px rgba(100, 100, 100, 0.3);\n}\n\n.itemSubmit {\n  margin-bottom: 0;\n  text-align: right;\n  margin-top: 20px;\n}\n\n.submit {\n  width: 250px;\n  font-weight: 700;\n  font-size: 13px;\n}\n\n.delete {\n  width: 150px;\n  margin-right: 20px;\n}\n\n.preview {\n  background-color: #f3f3f3;\n  height: 140px;\n  margin-bottom: 15px;\n  border-radius: 4px;\n  background-size: cover;\n  background-position: center;\n}\n.formItem{\n  display: flex;\n  gap:10px;\n}\n\n.plusMinusIcon{\n  cursor: pointer;\n}\n\n.innerHour{\n  width: 84%;\n}\n\n@media only screen and (max-width:650px) {\n  .innerHour{\n    width: 88%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editor": `Editor_editor__shROf`,
	"header": `Editor_header__DMbY9`,
	"title": `Editor_title__d6Vpo`,
	"label": `Editor_label__s6Cc8`,
	"input": `Editor_input__ykjJN`,
	"itemColumn": `Editor_itemColumn__TRlxY`,
	"uploadImage": `Editor_uploadImage__cxeql`,
	"center": `Editor_center__STrdu`,
	"labelSection": `Editor_labelSection__uNS7A`,
	"hoursList": `Editor_hoursList__5GvkH`,
	"labelHour": `Editor_labelHour__hSRoH`,
	"searchbox": `Editor_searchbox__1SfpN`,
	"mapWrapper": `Editor_mapWrapper__xVpRo`,
	"gps": `Editor_gps__MDS0J`,
	"itemSubmit": `Editor_itemSubmit__OIaKS`,
	"submit": `Editor_submit__MlQSb`,
	"delete": `Editor_delete__8kZqC`,
	"preview": `Editor_preview__T0QpS`,
	"formItem": `Editor_formItem__FiWEH`,
	"plusMinusIcon": `Editor_plusMinusIcon__LZenC`,
	"innerHour": `Editor_innerHour__8xcbv`
};
export default ___CSS_LOADER_EXPORT___;
